import React, { useState, useEffect, useRef } from 'react';
import Select, { components } from 'react-select';

const customStyles = {
  container: (provided) => ({
    ...provided,
    height: '100%',
  }),
  control: (provided, state) => ({
    ...provided,
    'borderRadius': '50px',
    'borderColor': state.selectProps.isError
      ? 'red'
      : state.isFocused
      ? '#EF80A0'
      : '#D9D9D9',
    'boxShadow': 'none',
    '&:hover': {
      borderColor: state.isErrors
        ? 'red'
        : state.isFocused
        ? '#EF80A0'
        : '#D9D9D9',
    },
    'padding': '0.5rem',
    'transition': 'colors',
    'transitionDelay': '300ms',
    'height': '100%',
    'cursor': 'pointer',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    'color': '#D9D9D9',
    '&:hover': {
      color: '#F8D8E4',
    },
    'cursor': 'pointer',
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '20px',
    borderColor: '#D9D9D9',
    marginTop: '0',
    marginBottom: '0',
    padding: '20px',
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '0',
    gap: '12px',
    listStyle: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    maxHeight: '250px',
  }),
  option: (provided, state) => ({
    ...provided,
    'color': state.isSelected ? '#EF80A0' : '#112932',
    'backgroundColor': 'white',
    'fontSize': '16px',
    'fontWeight': '500',
    'padding': '0',
    'cursor': 'pointer',
    'textTransform': 'capitalize',
    '&:hover': {
      color: '#EF80A0',
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#112932',
    fontSize: '16px',
    fontWeight: '500',
    marginLeft: '12px',
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: '#999999',
    position: 'relative',
    backgroundColor: 'transperent',
    paddingLeft: '4px',
    paddingRight: '4px',
    fontWeight: 600,
    display: state.isFocused ? 'none' : 'block',
  }),
  valueContainer: (provided) => ({
    ...provided,
    position: 'unset',
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
};

const CustomDropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <svg
        width='14'
        height='8'
        viewBox='0 0 14 8'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M13 1.00005C13 1.00005 8.5811 7 7 7C5.4188 7 1 1 1 1'
          stroke='#777777'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </components.DropdownIndicator>
  );
};

const DropDownField = ({
  options,
  defaultValue,
  value,
  // onBlur,
  isError,
  onChange,
  placeholder = '',
  isSearchable = false,
  label = '',
  isFullWidth = false,
  isLabelSticky = true,
  ...rest
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isCursorShow, setIsCursorShow] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value || defaultValue);
  const selectRef = useRef(null);
  useEffect(() => {
    setSelectedValue(value || defaultValue);
  }, [value, defaultValue]);

  const handleChange = (selectedOption) => {
    setSelectedValue(selectedOption);
    if (onChange) {
      onChange(selectedOption);
    }
  };

  const handleMenuOpen = () => {
    setIsCursorShow(true);
  };
  const handleSearchText = (e) => {
    if (e) {
      setIsCursorShow(false);
    } else {
      setIsCursorShow(true);
    }
  };
  return (
    <div
      className={`w-full min-w-52 h-auto relative flex flex-col ${
        isFullWidth ? 'w-full' : ''
      } ${isLabelSticky ? 'sm:h-12 md:h-[50px] xl:h-[52px]' : 'gap-2'}`}
    >
      {(isFocused || selectedValue || !isLabelSticky) && (
        <label
          className={`text-gray ${
            isLabelSticky
              ? 'absolute ml-[26px] pl-1 pr-1 w-fit bg-red-4 bg-gradient-to-b from-red-4 to-white -top-[9px] transition-all duration-300 z-[1] text-sm'
              : 'text-sm md:text-[16px] text-[14px] font-semibold text-gray-2 transition-all duration-300'
          }`}
        >
          {label}
        </label>
      )}
      <div className={`${isCursorShow ? 'hide-caret' : ''} `}>
        <Select
          ref={selectRef}
          isSearchable={isSearchable}
          value={selectedValue}
          className='react-select '
          classNamePrefix='select'
          styles={customStyles}
          label={label}
          options={options}
          defaultValue={defaultValue}
          placeholder={placeholder}
          onChange={handleChange}
          onMenuOpen={handleMenuOpen}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          isError={isError}
          components={{
            DropdownIndicator: CustomDropdownIndicator,
          }}
          onInputChange={(e) => handleSearchText(e)}
        />
      </div>
    </div>
  );
};

export default DropDownField;
